<template>
  <v-content>
    <v-container fluid>
      <div id="content">
        <h2>Mainte</h2>

        <!-- カバー -->
        <v-card outlined class="mb-10">
          <v-card-title>Cover</v-card-title>
          <v-card-text>
            <v-row class="grid-panel" align="center">
              <v-col class="add-btn" align="center" sm="2">
                <v-btn fab color="secondary" @click="coversDialog = true"><v-icon>fas fa-plus</v-icon></v-btn>
              </v-col>
              <v-col sm="2" v-for="item in covers" :key="item.id">
                <v-card outlined>
                  <v-img :src="getImage(item.eyecatch)" height="200px"></v-img>
                  <v-card-text>
                    <div class="title">{{ item.title }}</div>
                    <div class="date"><v-icon small>far fa-calendar-alt</v-icon>{{ getDate(item.date) }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout align-center justify-center row fill-height>
                      <v-btn text color="secondary" @click="coversEdit(item)"><v-icon small>fas fa-pencil-alt</v-icon></v-btn>
                      <v-btn text color="secondary" @click="coversDelete(item)"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- お知らせ -->
        <v-card outlined class="mb-10">
          <v-card-title>Topics</v-card-title>
          <v-card-text>
            <v-row class="grid-panel" align="center">
              <v-col class="add-btn" align="center" sm="2">
                <v-btn fab color="secondary" @click="topicsDialog = true"><v-icon>fas fa-plus</v-icon></v-btn>
              </v-col>
              <v-col sm="2" v-for="item in topics" :key="item.id">
                <v-card outlined>
                  <v-img :src="getImage(item.eyecatch)" height="200px"></v-img>
                  <v-card-text>
                    <div class="title">{{ item.title }}</div>
                    <div class="tags">
                      <ul class="list-inline">
                        <li v-for="tag in item.tags" :key="tag">
                          <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                        </li>
                      </ul>
                    </div>
                    <div class="date"><v-icon small>far fa-calendar-alt</v-icon>{{ getDate(item.date) }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout align-center justify-center row fill-height>
                      <v-btn text color="secondary" @click="topicsEdit(item)"><v-icon small>fas fa-pencil-alt</v-icon></v-btn>
                      <v-btn text color="secondary" @click="topicsDelete(item)"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- 実績 -->
        <v-card outlined>
          <v-card-title>Works</v-card-title>
          <v-card-text>
            <v-row class="grid-panel" align="center">
              <v-col class="add-btn" align="center" sm="2">
                <v-btn fab color="secondary" @click="worksDialog = true"><v-icon>fas fa-plus</v-icon></v-btn>
              </v-col>
              <v-col sm="2" v-for="item in works" :key="item.id">
                <v-card outlined>
                  <v-img :src="getImage(item.eyecatch)" height="200px"></v-img>
                  <v-card-text>
                    <div class="title">{{ item.title }}</div>
                    <div class="tags">
                      <ul class="list-inline">
                        <li v-for="tag in item.tags" :key="tag">
                          <v-chip small color="secondary" text-color="white">{{ tag }}</v-chip>
                        </li>
                      </ul>
                    </div>
                    <div class="date"><v-icon small>far fa-calendar-alt</v-icon>{{ getDate(item.date) }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout align-center justify-center row fill-height>
                      <v-btn text color="secondary" @click="worksEdit(item)"><v-icon small>fas fa-pencil-alt</v-icon></v-btn>
                      <v-btn text color="secondary" @click="worksDelete(item)"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- カバーダイアログ -->
        <v-dialog v-model="coversDialog" scrollable max-width="400px" persistent>
          <v-card>
            <v-card-title class="dialog-header">
              <span class="title font-weight-light">{{ coversFormTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="coversValid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field ref="coverTitle" v-model="coverItem.title" label="タイトル" :rules="[rules.required]" placeholder=" "></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <label>アイキャッチ画像</label>
                      <Upload :files="coverItem.eyecatch" @lightbox="lightboxFunc" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions class="dialog-footer">
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="coversSave" :loading="coversSaving" :disabled="!coversValid">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn text @click="coversClose">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- お知らせダイアログ -->
        <v-dialog v-model="topicsDialog" scrollable max-width="800px" persistent>
          <v-card>
            <v-card-title class="dialog-header">
              <span class="title font-weight-light">{{ topicsFormTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="topicsValid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field ref="title" v-model="topicItem.title" label="タイトル" :rules="[rules.required]" placeholder=" "></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea ref="detail" v-model="topicItem.detail" label="内容" :rules="[rules.required]" placeholder=" " auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-combobox ref="tags" v-model="topicItem.tags" :items="topicsTag" hide-selected multiple small-chips @input="topicsTagCheck" label="タグ" :rules="[rules.nolength]">
                        <template v-slot:selection="{ item, parent, selected }">
                          <v-chip :input-value="selected" small color="secondary" text-color="white">
                            <span class="pr-2">{{ item }}</span>
                            <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex xs12>
                      <label>アイキャッチ画像</label>
                      <Upload :files="topicItem.eyecatch" @lightbox="lightboxFunc" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions class="dialog-footer">
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="topicsSave" :loading="topicsSaving" :disabled="!topicsValid">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn text @click="topicsClose">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 実績ダイアログ -->
        <v-dialog v-model="worksDialog" scrollable max-width="800px" persistent>
          <v-card>
            <v-card-title class="dialog-header">
              <span class="title font-weight-light">{{ worksFormTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="worksValid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field ref="worksTitle" v-model="worksItem.title" label="タイトル" :rules="[rules.required]" placeholder=" "></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea ref="worksDetail" v-model="worksItem.detail" label="内容" :rules="[rules.required]" placeholder=" " auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-combobox ref="worksTags" v-model="worksItem.tags" :items="worksTag" hide-selected multiple small-chips @input="worksTagCheck" label="タグ" :rules="[rules.nolength]">
                        <template v-slot:selection="{ item, parent, selected }">
                          <v-chip :input-value="selected" small color="secondary" text-color="white">
                            <span class="pr-2">{{ item }}</span>
                            <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex xs12>
                      <label>アイキャッチ画像</label>
                      <Upload :files="worksItem.eyecatch" @lightbox="lightboxFunc" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions class="dialog-footer">
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="worksSave" :loading="worksSaving" :disabled="!worksValid">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn text @click="worksClose">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- lightboxダイアログ -->
        <v-dialog v-model="lightbox" max-width="600px">
          <v-img v-if="!!lightboxImage" :src="lightboxImage">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-dialog>
      </div>
    </v-container>
  </v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Upload from '@/components/Upload.vue'

export default {
  data() {
    return {
      menu: '',
      picker: '',
      terms: {
        topics: [],
        works: []
      },
      editedIndex: -1,
      //カバー
      covers: [],
      coverItem: {
        title: null,
        eyecatch: []
      },
      coversSaving: false,
      coversDialog: false,
      coversValid: false,
      //お知らせ
      topics: [],
      topicItem: {
        title: null,
        detail: null,
        tags: [],
        eyecatch: []
      },
      topicsSaving: false,
      topicsDialog: false,
      topicsValid: false,
      //実績
      works: [],
      worksItem: {
        title: null,
        detail: null,
        tags: [],
        eyecatch: []
      },
      worksSaving: false,
      worksDialog: false,
      worksValid: false,
      //lightboxもどき
      lightbox: false,
      lightboxImage: null,
      //入力ルール
      rules: {
        required: value => !!value || '入力は必須です',
        nolength: value => value.length > 0 || '選択してください'
      }
    }
  },
  computed: {
    coversMap() {
      const map = []
      this.covers.forEach(e => map.push(
        Object.assign({}, e)
      ))
      return map
    },
    coversFormTitle() {
      return this.editedIndex === -1 ? 'カバーの追加' : 'カバーの編集'
    },
    coversForm() {
      let form = Object.assign({}, {
        coverTitle: this.coverItem.title
      })
      return form
    },
    topicsMap() {
      const map = []
      this.topics.forEach(e => map.push(
        Object.assign({}, e)
      ))
      return map.reverse()
    },
    topicsTag() {
      const map = []
      this.terms.topics.forEach(e => map.push(e))
      return map
    },
    topicsFormTitle() {
      return this.editedIndex === -1 ? 'お知らせの追加' : 'お知らせの編集'
    },
    topicsForm() {
      let form = Object.assign({}, {
        title: this.topicItem.title,
        detail: this.topicItem.detail
      })
      return form
    },
    worksMap() {
      const map = []
      this.works.forEach(e => map.push(
        Object.assign({}, e)
      ))
      return map.reverse()
    },
    worksTag() {
      const map = []
      this.terms.works.forEach(e => map.push(e))
      return map
    },
    worksFormTitle() {
      return this.editedIndex === -1 ? '実績の追加' : '実績の編集'
    },
    worksForm() {
      let form = Object.assign({}, {
        worksTitle: this.worksItem.title,
        worksDetail: this.worksItem.detail
      })
      return form
    }
  },
  watch: {
    coversDialog(val) {
      val || this.coversClose()
    },
    topicsDialog(val) {
      val || this.topicsClose()
    },
    worksDialog(val) {
      val || this.worksClose()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let path = this
      //カバー
      firebase.database().ref('posts/covers').orderByChild('date').on('child_added', function(data) {
        path.covers.unshift(Object.assign({
          id: data.key,
        }, data.val()))
      })
      //お知らせ
      firebase.database().ref('posts/topics').orderByChild('date').on('child_added', function(data) {
        path.topics.unshift(Object.assign({
          id: data.key,
        }, data.val()))
      })
      //実績
      firebase.database().ref('posts/works').orderByChild('date').on('child_added', function(data) {
        path.works.unshift(Object.assign({
          id: data.key,
        }, data.val()))
      })
      //タグ
      firebase.database().ref('terms').on('child_added', function(data) {
        for (const id in data.val()) {
          path.terms[data.key].push(data.val()[id].name)
        }
      })
    },
    coversEdit(item) {
      this.editedIndex = this.covers.indexOf(item)
      this.coverItem = Object.assign({
        eyecatch: []
      }, item)
      this.coversDialog = true
    },
    coversDelete(item) {
      const path = this
      if (confirm(item.title + ' を削除しますか？')) {
        //topicsの削除
        firebase.database().ref('posts/covers/' + item.id).set(null, function(error) {
          if (error) {
            //console.log('お知らせの削除に失敗しました')
          } else {
            const index = path.covers.indexOf(item)
            path.covers.splice(index, 1)
          }
        })
      }
    },
    coversClose() {
      this.coversSaving = false
      this.coversDialog = false
      setTimeout(() => {
        this.coversReset()
        this.editedIndex = -1
      }, 300)
    },
    coversSave() {
      let validate = true
      Object.keys(this.coversForm).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        const path = this
        this.coversSaving = true
        let data = {
          title: this.coverItem.title,
          eyecatch: this.coverItem.eyecatch
        }

        if (this.editedIndex > -1) {
          //更新
          firebase.database().ref('posts/covers/' + this.coverItem.id).update(data, function(error) {
            if (error) {
              //console.log('お知らせの更新に失敗しました')
            } else {
              path.covers[path.editedIndex].title = path.coverItem.title
              path.covers[path.editedIndex].eyecatch = path.coverItem.eyecatch
              path.coversClose()
            }
          })

        } else {
          data.date = this.getLocalTime()
          //追加
          let new_key = firebase.database().ref('posts/covers').push().key
          firebase.database().ref('posts/covers/' + new_key).set(data, function(error) {
            if (error) {
              //console.log('お知らせの登録に失敗しました')
            } else {
              path.coversClose()
            }
          })
        }
      }
    },
    coversReset() {
      this.$refs['coverTitle'].reset()
      this.coverItem.eyecatch = []
    },
    topicsEdit(item) {
      this.editedIndex = this.topics.indexOf(item)
      this.topicItem = Object.assign({
        eyecatch: []
      }, item)
      this.topicsDialog = true
    },
    topicsDelete(item) {
      const path = this
      if (confirm(item.title + ' を削除しますか？')) {
        //topicsの削除
        firebase.database().ref('posts/topics/' + item.id).set(null, function(error) {
          if (error) {
            //console.log('お知らせの削除に失敗しました')
          } else {
            const index = path.topics.indexOf(item)
            path.topics.splice(index, 1)
          }
        })
      }
    },
    topicsClose() {
      this.topicsSaving = false
      this.topicsDialog = false
      setTimeout(() => {
        this.topicsReset()
        this.editedIndex = -1
      }, 300)
    },
    topicsSave() {
      let validate = true
      Object.keys(this.topicsForm).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        const path = this
        this.topicsSaving = true
        let data = {
          title: this.topicItem.title,
          detail: this.topicItem.detail,
          tags: this.topicItem.tags,
          eyecatch: this.topicItem.eyecatch
        }

        if (this.editedIndex > -1) {
          //更新
          firebase.database().ref('posts/topics/' + this.topicItem.id).update(data, function(error) {
            if (error) {
              //console.log('お知らせの更新に失敗しました')
            } else {
              path.topics[path.editedIndex].title = path.topicItem.title
              path.topics[path.editedIndex].detail = path.topicItem.detail
              path.topics[path.editedIndex].tags = path.topicItem.tags
              path.topics[path.editedIndex].eyecatch = path.topicItem.eyecatch
              path.topicsClose()
            }
          })

        } else {
          data.date = this.getLocalTime()
          //追加
          let new_key = firebase.database().ref('posts/topics').push().key
          firebase.database().ref('posts/topics/' + new_key).set(data, function(error) {
            if (error) {
              //console.log('お知らせの登録に失敗しました')
            } else {
              path.topicsClose()
            }
          })
        }
      }
    },
    topicsTagCheck() {
      let path = this
      this.topicItem.tags.forEach(function(tag) {
        if (!path.terms.topics.find(cate => cate === tag)) {
          //追加
          let new_key = firebase.database().ref('terms/topics').push().key
          firebase.database().ref('terms/topics/' + new_key).set({ name: tag }, function(error) {
            if (error) {
              //console.log('タグの登録に失敗しました')
            } else {
              path.terms.topics.push(tag)
              return
            }
          })
        }
      })
    },
    topicsReset() {
      this.$refs['title'].reset()
      this.$refs['detail'].reset()
      this.$refs['tags'].reset()
      this.topicItem.eyecatch = []
    },
    //実績
    worksEdit(item) {
      this.editedIndex = this.works.indexOf(item)
      this.worksItem = Object.assign({
        eyecatch: []
      }, item)
      this.worksDialog = true
    },
    worksDelete(item) {
      const path = this
      if (confirm(item.title + ' を削除しますか？')) {
        //worksの削除
        firebase.database().ref('posts/works/' + item.id).set(null, function(error) {
          if (error) {
            //console.log('実績の削除に失敗しました')
          } else {
            const index = path.works.indexOf(item)
            path.works.splice(index, 1)
          }
        })
      }
    },
    worksClose() {
      this.worksSaving = false
      this.worksDialog = false
      setTimeout(() => {
        this.worksReset()
        this.editedIndex = -1
      }, 300)
    },
    worksSave() {
      let validate = true
      Object.keys(this.worksForm).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        const path = this
        this.worksSaving = true
        let data = {
          title: this.worksItem.title,
          detail: this.worksItem.detail,
          tags: this.worksItem.tags,
          eyecatch: this.worksItem.eyecatch
        }

        if (this.editedIndex > -1) {
          //更新
          firebase.database().ref('posts/works/' + this.worksItem.id).update(data, function(error) {
            if (error) {
              //console.log('実績の更新に失敗しました')
            } else {
              path.works[path.editedIndex].title = path.worksItem.title
              path.works[path.editedIndex].detail = path.worksItem.detail
              path.works[path.editedIndex].tags = path.worksItem.tags
              path.works[path.editedIndex].eyecatch = path.worksItem.eyecatch
              path.worksClose()
            }
          })

        } else {
          data.date = this.getLocalTime()
          //追加
          let new_key = firebase.database().ref('posts/works').push().key
          firebase.database().ref('posts/works/' + new_key).set(data, function(error) {
            if (error) {
              //console.log('実績の登録に失敗しました')
            } else {
              path.worksClose()
            }
          })
        }
      }
    },
    worksTagCheck() {
      let path = this
      this.worksItem.tags.forEach(function(tag) {
        if (!path.terms.works.find(cate => cate === tag)) {
          //追加
          let new_key = firebase.database().ref('terms/works').push().key
          firebase.database().ref('terms/works/' + new_key).set({ name: tag }, function(error) {
            if (error) {
              //console.log('タグの登録に失敗しました')
            } else {
              path.terms.works.push(tag)
              return
            }
          })
        }
      })
    },
    worksReset() {
      this.$refs['worksTitle'].reset()
      this.$refs['worksDetail'].reset()
      this.$refs['worksTags'].reset()
      this.worksItem.eyecatch = []
    },
    lightboxFunc(item) {
      this.lightbox = true
      this.lightboxImage = item.original
    }
  },
  components: {
    Upload
  }
}
</script>

<style lang="scss" scoped>
.grid-panel {
  padding: 0;
  margin: 0;
  .col {
    vertical-align: top;
    display: inline-block;
    width: 300px;
    padding: 5px;
    .title {
      font-size: 14px !important;
      font-weight: bold;
    }
    .date {
      text-align: right;
      i {
        vertical-align: baseline;
        margin-right: 5px;
      }
    }
  }
}
ul.list-inline {
  margin: 0;
  padding: 0;
  list-style: none;
  > li {
    display: inline-block;
    width: auto;
    padding: 5px 0;
  }
}
.flip {
  &-move {
    transition: transform 0.5s;
  }
  &-enter {
    &-active {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
      transition: opacity 0.5s, transform 0.5s;
    }
    &-to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
  &-leave {
    &-active {
      position: absolute;
      transition: opacity 0.5s, transform 0.5s;
    }
    &-to {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
    }
  }
}
form {
  label {
    color: #999;
    font-size: 12px;
    margin-bottom: 10px;
    display: block;
  }
}
</style>
